<div class="margin-top-3">
  <app-logo-with-subtitle></app-logo-with-subtitle>
</div>

<div class="homepage-container margin-top-4">
  <ngx-spinner
    color="#D73647"
    bdColor="#00000050"
    [fullScreen]="false"
    size="medium"
  >
    <div>Checking available studies...</div>
  </ngx-spinner>

  <div *ngIf="!isLoading && !error" class="studies-container">
    <h2 class="studies-title">Choose your GWAS study to explore:</h2>

    <div class="study-cards">
      <!-- GWAS 1-5 Card -->
      <div
        class="study-card"
        [class.disabled]="!grch37Available"
        (click)="navigateToGWAS15()"
      >
        <div class="card-header">
          <h3>GWAS 1-5</h3>
          <span class="study-label">Study</span>
        </div>
        <div class="card-body">
          <p class="dataset-info">Single Dataset</p>
          <p class="genome-info">(GRCh37)</p>
          <p class="doi-info">
            <a href="https://doi.org/10.1016/j.cell.2019.06.036" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
              10.1016/j.cell.2019.06.036
            </a>
          </p>
        </div>
        <div *ngIf="!grch37Available" class="unavailable-overlay">
          <span>Currently Unavailable</span>
        </div>
      </div>

      <!-- GWAS 1-6 Card -->
      <div class="study-card" (click)="navigateToGWAS16()">
        <div class="card-header">
          <h3>GWAS 1-6</h3>
          <span class="study-label">Study</span>
        </div>
        <div class="card-body">
          <p class="dataset-info">Multiple Datasets</p>
          <p class="genome-info">(GRCh38)</p>
          <p class="doi-info">
            <a href="https://doi.org/10.1038/s41588-025-02191-5" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
              10.1038/s41588-025-02191-5
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="error-message">
    <p>Error loading studies: {{ error.status }} - {{ error.message }}</p>
    <button nbButton status="primary" (click)="checkGRCh37Availability()">
      Retry
    </button>
  </div>
</div>
